import React from 'react';
import Navbar from '../../components/Navbar2';
import Contact from '../../components/Contact';
import './index.css';

const AsiaWonderlustPage = () => {
  return (
    <div className="collection-page">
      <Navbar />

      {/* Hero Section */}
      <div
        className="collection-hero"
        style={{
          backgroundImage: "url('https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxe%2Fgetty-images-053OMOzZAUI-unsplash.jpg?alt=media&token=76216d75-0af4-4463-b559-a4dd96fd96a7')",
        }}
      >
        <div className="collection-hero-overlay" />
        <div className="collection-hero-content">
          <p className="collection-hero-label">Collections</p>
          <h1 className="collection-hero-title">Asia Wonderlust</h1>
          <p className="collection-hero-sub">
            Discover the mystique, grandeur, and timeless elegance of Asia.
          </p>
        </div>
      </div>

      {/* Coming Soon Section */}
      <div className="collection-coming-soon">
        <p className="collection-cs-label">Coming Soon</p>
        <h2 className="collection-cs-title">Launching After Eat Pray Love</h2>
        <p className="collection-cs-text">
          Our Asia Wonderlust collection will bring together the finest properties across Asia's most captivating destinations — from the serene temples of Bali to the vibrant streets of Tokyo. An extraordinary journey awaits.
        </p>
        <div className="collection-cs-divider" />
        <p className="collection-cs-notify">
          Register your interest to be notified when this collection launches.
        </p>
      </div>

      <Contact />
    </div>
  );
};

export default AsiaWonderlustPage;
